import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { ParkingSpace } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "ParkingSpace";
export const ParkingSpaceService = {
	endpoint,
	createSingle: async (data: ParkingSpace) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: ParkingSpace) => await Service.updateSingleById(endpoint, id, data),
}